import ReactDOM from 'react-dom';
import { App } from './components/App';

import './assets/styles/main.scss';

ReactDOM.render(<App />, document.getElementById('root'));
